export class Financiamento {
  ativo: boolean;
  usaControleTarefas: boolean;
  valorMin: number;
  valorMax: number;
  ordemSelecao: number;
  prazoExpiracao: number;
  termo: string;
  usaTermo: boolean;
  validaExpiracaoProposta: boolean;
  envioCelulaSimulacao: number[];
  usaMonitorProposta: boolean;
  usaFunilPorFinanciadora: boolean;
  funilMonitorProposta: number | undefined;
  liberarPropostasAutomaticamente: boolean;
}
